let isExpanded = false;

const showTopic = (topicHandle, topicName) => {
  const tabsContent = document.querySelector('.tabs__content-items');
  const topicNameEl = document.querySelector('.tabs__content-topic-name');
  const allItems = document.querySelectorAll('.tabs__item');
  const expandAllBtn = document.querySelector('.tabs__expand-all');
  
  if (topicNameEl) {
    topicNameEl.textContent = topicName;
  }
  
  isExpanded = false;
  if (expandAllBtn) {
    expandAllBtn.textContent = 'Expand All';
  }
  
  allItems.forEach((item) => {
    item.classList.remove('tabs__item--active');
    item.classList.add('tabs__item--inactive');
  });
  
  const matchingItems = tabsContent.querySelectorAll(`[data-topic="${topicHandle}"]`);
  matchingItems.forEach((item) => {
    item.classList.remove('tabs__item--inactive');
    item.classList.add('tabs__item--active');
  });
  
  collapseAll();
  
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

const expandAll = () => {
  const activeItems = document.querySelectorAll('.tabs__item--active .details');
  activeItems.forEach((item) => {
    if (!item.classList.contains('details--active')) {
      item.classList.add('details--active');
      const button = item.querySelector('.summary');
      const content = item.querySelector('.details__content');
      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }
      if (content) {
        content.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = '';
      }
    }
  });
};

const collapseAll = () => {
  const activeItems = document.querySelectorAll('.tabs__item--active .details');
  activeItems.forEach((item) => {
    if (item.classList.contains('details--active')) {
      item.classList.remove('details--active');
      const button = item.querySelector('.summary');
      const content = item.querySelector('.details__content');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
      if (content) {
        content.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '';
      }
    }
  });
};

const updateActiveState = (topicHandle, topicName) => {
  const topicTriggers = document.querySelectorAll('.tabs__header .topic-trigger');
  topicTriggers.forEach((tab) => tab.classList.remove('link-styled--active'));
  const activeTrigger = document.querySelector(`.topic-trigger[data-topic="${topicHandle}"]`);
  if (activeTrigger) {
    activeTrigger.classList.add('link-styled--active');
  }
  
  const select = document.getElementById('TabsHeaderSelect');
  if (select) {
    select.value = topicHandle;
  }
  
  showTopic(topicHandle, topicName);
  
  window.location.hash = topicHandle;
};

(() => {
  const topicTriggers = document.querySelectorAll('.tabs__header .topic-trigger');
  
  topicTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const topicHandle = trigger.dataset.topic;
      const topicName = trigger.textContent.trim();
      updateActiveState(topicHandle, topicName);
    });
  });

  const select = document.getElementById('TabsHeaderSelect');
  if (select) {
    select.addEventListener('change', (e) => {
      const topicHandle = e.target.value;
      const selectedOption = e.target.options[e.target.selectedIndex];
      const topicName = selectedOption.textContent.trim();
      updateActiveState(topicHandle, topicName);
    });
  }

  const expandAllBtn = document.querySelector('.tabs__expand-all');
  
  if (expandAllBtn) {
    expandAllBtn.addEventListener('click', () => {
      if (isExpanded) {
        collapseAll();
        expandAllBtn.textContent = 'Expand All';
        isExpanded = false;
      } else {
        expandAll();
        expandAllBtn.textContent = 'Collapse All';
        isExpanded = true;
      }
    });
  }

  const hash = window.location.hash;
  
  if (hash) {
    const topicHandle = hash.slice(1);
    const trigger = document.querySelector(`.topic-trigger[data-topic="${topicHandle}"]`);
    
    if (trigger) {
      const topicName = trigger.textContent.trim();
      updateActiveState(topicHandle, topicName);
    } else {
      const firstTrigger = document.querySelector('.tabs__header .topic-trigger');
      if (firstTrigger) {
        const topicHandle = firstTrigger.dataset.topic;
        const topicName = firstTrigger.textContent.trim();
        updateActiveState(topicHandle, topicName);
      }
    }
  } else {
    setTimeout(() => {
      const firstTrigger = document.querySelector('.tabs__header .topic-trigger');
      if (firstTrigger) {
        const topicHandle = firstTrigger.dataset.topic;
        const topicName = firstTrigger.textContent.trim();
        updateActiveState(topicHandle, topicName);
      }
    }, 100);
  }
})();